export const MAX_CARD_NOTE_LENGTH = 500;
/** A note as it is stored: trimmed, line breaks kept, at most 500 characters; null when empty. */
export function cleanCardNote(text) {
    if (typeof text !== 'string')
        return null;
    const clean = text
        .replace(/\r\n?/g, '\n')
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u0009\u000b-\u001f\u007f]/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
        .slice(0, MAX_CARD_NOTE_LENGTH)
        .trim();
    return clean || null;
}
export function cardNote(card, side) {
    return (side === 'front' ? card.note_front : card.note_back) ?? null;
}
/**
 * The card with one of its notes set (or removed, with an empty text). `stamp` is the moment of
 * the change; it becomes `notes_updated_at`, which decides between two devices' notes.
 */
export function withCardNote(card, side, text, stamp) {
    const note = cleanCardNote(text);
    return {
        ...card,
        ...(side === 'front' ? { note_front: note } : { note_back: note }),
        notes_updated_at: stamp,
    };
}
/**
 * Notes are merged apart from the rest of the card: the copy whose notes changed last keeps its
 * notes, whichever copy has the newer reviews. So a note written on one device is not lost to a
 * review made on another device that had not seen the note yet.
 */
export function mergeCardNotes(winner, loser) {
    const at = (card) => card.notes_updated_at ? new Date(card.notes_updated_at).getTime() : 0;
    if (at(loser) <= at(winner))
        return winner;
    return {
        ...winner,
        note_front: loser.note_front ?? null,
        note_back: loser.note_back ?? null,
        notes_updated_at: loser.notes_updated_at,
    };
}
export function sameCardNotes(a, b) {
    return ((a.note_front ?? null) === (b.note_front ?? null) &&
        (a.note_back ?? null) === (b.note_back ?? null) &&
        (a.notes_updated_at ?? null) === (b.notes_updated_at ?? null));
}
